import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TopHeaderForBuyer } from 'ui/components/panes/Header/TopHeaderForBuyer';

const BgWrapper = styled.div`
    background-color: var(--light-orange);
    min-height: calc(100vh - var(--height-top-header));

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 16px;
`;

const Wrapper = styled.div`
    margin: 20px auto;
    padding: 40px 30px;
    border-radius: 12px;
    background-color: var(--white);
    max-width: 1000px;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: var(--font-medium);
    text-align: center;

    h4 {
        color: var(--dark-blue);
    }

    ${mqMin('SP')} {
        margin: 0 auto;
        width: 100%;
        padding: 30px 16px;
        font-size: 0.9rem;
        gap: 16px;
    }
`;

const Title = styled.div`
    font-size: var(--font-large);
    color: var(--primary);
    font-weight: 600;
    margin-bottom: 20px;
    text-align: left;

    ${mqMin('NARROW')} {
        font-size: var(--font-xxx-large);
        text-align: center;
    }
`;

const CompleteText = styled.div`
    margin: 0 auto;
    font-size: var(--font-medium);
    line-height: 1.5;
    text-align: left;

    ${mqMin('NARROW')} {
        font-size: 0.9rem;
        text-align: center;
    }
`;

export const SentRegistrationMailForBuyer: React.FC = () => {
    return (
        <>
            <TopHeaderForBuyer />
            <BgWrapper>
                <Wrapper>
                    <Title>確認用メールを送信しました</Title>
                    <CompleteText>
                        入力いただいたメールアドレス宛に確認用のメールを送信しました。
                        <br />
                        メールに記載されている認証URLをクリックして、本登録を行なってください。
                    </CompleteText>
                </Wrapper>
            </BgWrapper>
        </>
    );
};
